'use client';

import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';

// Non-critical page chrome (toasts, the PWA install banner) code-split out of
// the hydration bundle and mounted at first idle. Nothing here can be needed
// in the first seconds of a visit: toasts fire on user actions (sonner queues
// any fired before its Toaster mounts), and the install banner is gated on 2+
// pageviews anyway.
const Toaster = dynamic(() => import('@kit/ui/sonner').then((m) => m.Toaster), {
  ssr: false,
});
const PWAInstallPrompt = dynamic(
  () =>
    import('~/components/pwa/pwa-install-prompt').then(
      (m) => m.PWAInstallPrompt,
    ),
  { ssr: false },
);

export function DeferredChrome({ theme }: { theme: string }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(() => setReady(true), {
        timeout: 5000,
      });
      return () => window.cancelIdleCallback(id);
    }

    const t = setTimeout(() => setReady(true), 3000);
    return () => clearTimeout(t);
  }, []);

  if (!ready) return null;

  return (
    <>
      <Toaster
        richColors={true}
        theme={theme as 'light' | 'dark' | 'system'}
        position="top-center"
      />
      <PWAInstallPrompt />
    </>
  );
}
